import {
  getStatusBadge,
  mapBookedContactMethod,
  getCenterName,
  getPatientName,
  isUpcomingAppointment,
} from '@avanta/shared/utils/appointments';
import { compareAsc, compareDesc, isBefore, startOfToday } from 'date-fns';
import { type Appointment } from 'types/appointments';

export {
  getStatusBadge,
  mapBookedContactMethod,
  getCenterName,
  getPatientName,
  isUpcomingAppointment,
};

export const separateAppointmentsByDate = (
  appointments: Appointment[]
): { past: Appointment[]; future: Appointment[] } => {
  const today = startOfToday();
  const past = appointments
    .filter(apt => isBefore(new Date(apt.dateTime), today))
    .sort((a, b) => compareDesc(new Date(a.dateTime), new Date(b.dateTime)));

  const future = appointments
    .filter(apt => !isBefore(new Date(apt.dateTime), today))
    .sort((a, b) => compareAsc(new Date(a.dateTime), new Date(b.dateTime)));

  return { past, future };
};

export const CONTACT_METHOD_KEY: Record<string, string> = {
  'in-person': 'inPerson',
  video: 'video',
  remote: 'remote',
};
